<script setup>
import {MenuItem} from "@headlessui/vue";
const props = defineProps({
  as: {
    type: String,
    default: 'a',
    required: false
  },
  description: {
    type: String,
    required: false
  }
})
</script>

<template>
  <MenuItem v-slot="{ active }">
    <component :is="as"
        :class="[
                          active ? 'bg-red-main text-gray-500' : 'text-gray-400',
                          'group flex flex-col  w-full items-left rounded-md px-2 py-2 text-sm',
                        ]"
    >
      <span><slot /></span>
      <span v-if="description" class="mt-0.5 text-left text-xs text-gray-500 group-hover:text-white">{{description}}</span>
    </component>
  </MenuItem>
</template>

<style scoped>

</style>
